import { Box, Flex } from '@chakra-ui/react';
import React from 'react';
import { LARGURA_PRODUTO } from './constantes';

/** O editor não busca produto: a silhueta só mostra o enquadramento da faixa. */
const SilhuetaProduto: React.FC = () => (
  <Flex
    direction="column"
    flexShrink={0}
    w={`${LARGURA_PRODUTO}px`}
    borderWidth="1px"
    borderColor="gray.200"
    borderRadius="8px"
    bg="white"
    p={2}
    gap={2}
  >
    <Box w="100%" h="70px" bg="gray.100" borderRadius="4px" />
    <Box w="100%" h="8px" bg="gray.100" borderRadius="2px" />
    <Box w="70%" h="8px" bg="gray.100" borderRadius="2px" />
    <Box w="50%" h="10px" bg="gray.200" borderRadius="2px" mt={1} />
    <Box w="100%" h="20px" bg="gray.300" borderRadius="4px" mt={1} />
  </Flex>
);

export default SilhuetaProduto;
